<!--
  - Copyright (c) 2020.
  - Project: Source
  - LastModified: 2/14/20, 3:24 PM
  - Author: diengv < Giáp Văn Điện >
  - Email: diengv@ominext.com
  - File name: footer-layout.vue
  - File path: D:/Projects/PMS/Source/Client/vuejs/src/resources/layout/inc/footer-layout.vue
  -->

<template>
  <footer class="footer">
    <div class="columns">
      <div class="column"><h3>Navigation</h3>
        <hr>
        <ul>
          <li><a href="/features" class="">Features</a></li>
          <li><a href="/pricing" class="">Pricing</a></li>
          <li><a href="/login" class="">Login/Signup</a></li>
        </ul>
      </div>
      <div class="column"><h3>Information</h3>
        <hr>
        <ul>
          <li><a href="/about" class="">About</a></li>
          <li><a href="/jobs" class="">Jobs&nbsp;<span class="tag is-rounded is-primary">We're hiring!</span></a></li>
          <li><a href="/customers" class="">Customers</a></li>
        </ul>
      </div>
      <div class="column"><h3>Resources</h3>
        <hr>
        <ul>
          <li><a href="/support" class="">Support</a></li>
          <li><a href="/copyrights" class="">Copyright &amp; credits</a></li>
          <li><a href="/press" class="">Press</a></li>
          <li><a href="/contact" class="">Contact</a></li>
        </ul>
      </div>
    </div>
    <div class="columns is-centered has-text-centered">
      <div class="column is-6 company-info"><p>© TMRD Ltd 2018. All rights reserved. <a href="/privacy" class="">Privacy</a>
        &amp; <a href="/terms" class="">Terms</a></p>
        <p>TMRD Ltd is registered in England &amp; Wales, company registration number 11599040</p></div>
    </div>
  </footer>
</template>

<script>
    export default {
        name: "footer-layout"
    }
</script>

<style scoped>

</style>
